var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralChillerTower = function SvgPGeneralChillerTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.1,
    y: 376.8,
    width: 68,
    height: 28.6,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.7,
    y: 412.1,
    width: 68.5,
    height: 18,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,405.3c5.5,0,9-6.2,9-14.2s-3.5-14.3-9-14.3",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "271.9,388.1 278.1,388.1 278.1,394.1 271.9,394.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "269.8,418.1 276.1,418.1 276.1,424.1 269.7,424.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,405.3c-5.5,0-9-6.2-9-14.1s3.5-14.2,9-14.2",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "186.6,387.1 180.1,387.1 180.1,395.1 186.6,395.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,412.1c4.6,0,7,4,7,9s-2.4,8.9-7,8.9",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,412.1c-4.6,0-7.7,4-7.7,9s3,8.9,7.7,8.9",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,392.2h1.6c1.4,0,2.5,1.1,2.5,2.5v26.5c0,1.4-1.1,2.5-2.5,2.5H206c-1.4,0-2.5-1.1-2.5-2.5v-26.5 C203.5,393.3,204.6,392.2,206,392.2z",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,352.6c5.1,0,9.2,4.4,9.2,9.4v10.3h-6.6v-10.9c0-1.3-1.1-2.3-2.3-2.3h-19.6v-6.6L249.1,352.6 L249.1,352.6z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,361.4c-2.3,0-3.2,1.1-3.2,3.1v5.6h-11V362c0-6.2,4.9-11.5,11.1-11.5h17.5v11L215.4,361.4L215.4,361.4z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 388.1,
    width: 24,
    height: 30,
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "194.1,436 194.1,376.8 196.1,376.8 196.1,436",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 436.1,
    width: 10,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "262.1,436.1 262.1,376.8 264.1,376.8 264.1,436.1",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 436.1,
    width: 10,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "216.6,376.9 216.6,370.2 196.8,370.2 196.8,376.9",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "258.3,376.9 258.3,372.4 251.7,372.4 251.7,376.9",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 376.8,
    width: 68,
    height: 28.6,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 412.1,
    width: 68.5,
    height: 18,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,405.3c5.5,0,9-6.2,9-14.2s-3.5-14.3-9-14.3",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "203.9,388.1 210.1,388.1 210.1,394.1 203.9,394.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.8,418.1 208.1,418.1 208.1,424.1 201.7,424.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,405.3c-5.5,0-9-6.2-9-14.1s3.5-14.2,9-14.2",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "118.6,387.1 112.1,387.1 112.1,395.1 118.6,395.1",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,412.1c4.6,0,7,4,7,9s-2.4,8.9-7,8.9",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,412.1c-4.6,0-7.7,4-7.7,9s3,8.9,7.7,8.9",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,392.2h1.6c1.4,0,2.5,1.1,2.5,2.5v26.5c0,1.4-1.1,2.5-2.5,2.5H138c-1.4,0-2.5-1.1-2.5-2.5v-26.5 C135.5,393.3,136.6,392.2,138,392.2z",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,352.6c5.1,0,9.2,4.4,9.2,9.4v10.3h-6.6v-10.9c0-1.3-1.1-2.3-2.3-2.3h-19.6v-6.6L181.1,352.6 L181.1,352.6z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,361.4c-2.3,0-3.2,1.1-3.2,3.1v5.6h-11V362c0-6.2,4.9-11.5,11.1-11.5h17.5v11L147.4,361.4L147.4,361.4z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.1,
    y: 388.1,
    width: 24,
    height: 30,
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "126.1,436 126.1,376.8 128.1,376.8 128.1,436",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.1,
    y: 436.1,
    width: 10,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "194.1,436.1 194.1,376.8 196.1,376.8 196.1,436.1",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 436.1,
    width: 10,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.6,376.9 148.6,370.2 128.8,370.2 128.8,376.9",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "190.3,376.9 190.3,372.4 183.7,372.4 183.7,376.9",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.5,94.1c1.1-1.8,1.7-3.9,1.7-6.1s-0.6-4.1-1.7-5.9h31.4c-1.1,1.9-1.7,3.7-1.7,5.9s0.6,4.2,1.7,6.1H123.5z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,90.7h4.1c0.2,0,0.4,0.2,0.4,0.4v1.2c0,0.2-0.2,0.4-0.4,0.4h-4.1c-0.2,0-0.4-0.2-0.4-0.4v-1.2 C136.6,90.9,136.7,90.7,136.9,90.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 92.7,
    width: 1.7,
    height: 1.4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.2,90.9 142.6,92.4 149.8,92.8 151.8,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,92.1h-1.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S143.1,92.1,142.9,92.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.8,90.9 135.4,92.4 128.1,92.8 126.2,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,92.1h-1.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S136.7,92.1,136.5,92.1z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.4,94.1c1.1-1.8,1.7-3.9,1.7-6.1s-0.6-4.1-1.7-5.9h31.4c-1.1,1.9-1.7,3.7-1.7,5.9s0.6,4.2,1.7,6.1H165.4z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,90.7h4.1c0.2,0,0.4,0.2,0.4,0.4v1.2c0,0.2-0.2,0.4-0.4,0.4h-4.1c-0.2,0-0.4-0.2-0.4-0.4v-1.2 C178.5,90.9,178.6,90.7,178.8,90.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 92.7,
    width: 1.7,
    height: 1.4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.1,90.9 184.6,92.4 191.8,92.8 193.7,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,92.1h-1.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S185.1,92.1,184.9,92.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.7,90.9 177.3,92.4 170.1,92.8 168.1,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,92.1H177c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S178.6,92.1,178.4,92.1z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.3,94.1c1.1-1.8,1.8-3.9,1.8-6.1s-0.6-4.1-1.8-5.9h31.4c-1.1,1.9-1.8,3.7-1.8,5.9s0.6,4.2,1.8,6.1H207.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,90.7h4.1c0.2,0,0.4,0.2,0.4,0.4v1.2c0,0.2-0.2,0.4-0.4,0.4h-4.1c-0.2,0-0.4-0.2-0.4-0.4v-1.2 C220.4,90.9,220.6,90.7,220.8,90.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 92.7,
    width: 1.7,
    height: 1.4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.1,90.9 226.5,92.4 233.7,92.8 235.7,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,92.1h-1.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S227,92.1,226.8,92.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.7,90.9 219.2,92.4 212,92.8 210.1,90.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3,92.1h-1.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4S220.5,92.1,220.3,92.1z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 94.1,
    width: 130,
    height: 40,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "246.1,146.1 246.1,94.1 240.1,94.1 240.1,146.1",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122.1,146.1 122.1,94.1 116.1,94.1 116.1,146.1",
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10
  }))));
};
export default SvgPGeneralChillerTower;